import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.33333 8.66669V8.00002M8 8.66669V6.66669M10.6667 8.66669V5.33335M5.33333 14L8 11.3334L10.6667 14M2 2.66669H14M2.66667 2.66669H13.3333V10.6667C13.3333 11.0349 13.0349 11.3334 12.6667 11.3334H3.33333C2.96514 11.3334 2.66667 11.0349 2.66667 10.6667V2.66669Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }